var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouDiy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    transform: "translate(1 1.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.104 29.734h24.38v24.38H.104z",
    "data-name": "Rectangle 14412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.211 54.534 2.486 8.667-.551 8.506",
    "data-name": "Path 40139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.807 71.853 11.1-.06.03 5.5-11.1.06z",
    "data-name": "Rectangle 14413"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.067 54.626.566 8.575-1.981 8.6",
    "data-name": "Path 40140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 72.156h11.1v5.5H0z",
    "data-name": "Rectangle 14414"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.263,
    cy: 12.262,
    "data-name": "Ellipse 732",
    rx: 12.263,
    ry: 12.262,
    transform: "translate(.402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.402 12.262 38.131 0",
    "data-name": "Line 4303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.288 52.018-7.413-3.511-.987-13.854",
    "data-name": "Path 40141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.099 18.696s-2.953 1.492-4.559.4",
    "data-name": "Path 40142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.413,
    cy: 0.413,
    r: 0.413,
    "data-name": "Ellipse 733",
    transform: "translate(19.733 11.099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.206 16.148-4.957 7.244-9.669 6.342",
    "data-name": "Path 40143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.616 16.362-2.547-.673",
    "data-name": "Line 4304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.534 16.813.734-2.241",
    "data-name": "Line 4305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.287 19.545-4.154-7.619 3.565-1.943-1.484-2.387s-2.846 3.328-5.875 1.622l1.828 3.718 1.958-1.01",
    "data-name": "Path 40144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.305.405v77.606",
    "data-name": "Line 4306"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouDiy);
export default __webpack_public_path__ + "static/media/youDiy.4ece09d025a216043b11777092ea413e.svg";
export { ForwardRef as ReactComponent };